module.exports = __webpack_public_path__ + "static/media/2025_Air_Greenland.38ac6fc5.pdf";